export class RichDropdownConfig {
	private defaults = { itemTemplateUrl: 'rich-dropdown/rich-dropdown-list-item-template.directive.html' };

	public $get = () => {
		return this.defaults;
	};

}
